import {sendMessage as sendMessageApi, firstMessage as firstMessageApi,
    firstMessageList as firstMessageListApi, showfirstMessage as showFirstMessageApi,
    showMessage as showMessageApi, retrievePhoto as retrievePhotoApi,
    showAllList as showAllListApi, showLastMsg as showLastMsgApi,
} from "../apis/message";

export function sendMessage(payload){
    return async (dispatch) => {
        let result = await sendMessageApi(payload);
        console.log("send message result", result);
        return result;
    }
};

export function firstMessage(payload){
    return async (dispatch) => {
        let result = await firstMessageApi(payload);
        console.log("first message result", result);
        return result;
    }
};

export function firstMessageList(payload){
    return async (dispatch) => {
        let result = await firstMessageListApi(payload);
        // console.log("first message result", result);
        return result;
    }
};

export function showFirstMessage(payload){
    return async (dispatch) => {
        let result = await showFirstMessageApi(payload);
        // console.log("first message result", result);
        return result;
    }
};

export function showMessage(payload){
    return async (dispatch) => {
        let result = await showMessageApi(payload);
        // console.log("first message result", result);
        return result;
    }
};

export function retrievePhoto(payload){
    return async (dispatch) => {
        let result = await retrievePhotoApi(payload);
        // console.log("first message result", result);
        return result;
    }
};

export function showAllList(payload){
    return async (dispatch) => {
        let result = await showAllListApi(payload);
        // console.log("first message result", result);
        return result;
    }
};

export function showLastMsg(payload){
    return async (dispatch) => {
        let result = await showLastMsgApi(payload);
        // console.log("first message result", result);
        return result;
    }
};
